const Description = ({ className, children, wrapperClass }) => {
  return (
    <div className={`flex justify-center items-center ${wrapperClass ?? ''}`}>
      <p className={`break-words ttnk-AvenirNextFont ${className ?? ''}`}>{children}</p>
    </div>
  );
};

export default Description;
